const UpdateFormMessages = {
  FormH1: 'Define una nueva contraseña',
  placeHolderInput1: 'Contraseña',
  placeHolderInput2: 'Confirmación',
  textButton: 'Actualizar',
}

export default UpdateFormMessages
